export const APP_CONFIG = {
    APP_NAME: 'Alpha Air Self-Service',
    COMPANY_NAME: 'Alpha Air',
    CONTACT_EMAIL: 'info@alphaair.com.au',
    CONTACT_PHONE: '1300864703',
    DEFAULT_BOOKING_DURATION: 60, // minutes
    BOOKING_SLOTS_PER_DAY: 16,
    MAX_BOOKING_DAYS_AHEAD: 30,
    SESSION_TIMEOUT: 30 * 60 * 1000, // 30 minutes in milliseconds
};

export const BOOKING_OPTIONS = [
    { id: 'estimate', label: 'Get an Estimate', description: 'Price Estimation from Measurements', duration: 30 },
    { id: 'consultation', label: 'Book Consultation', description: 'Office Quote / Onsite Sales Consultation', duration: 30 }
];

export const TIME_SLOTS = {
    MORNING: { start: '09:00', end: '12:00', label: 'Morning' },
    AFTERNOON: { start: '13:00', end: '17:00', label: 'Afternoon' }
};

export const BOOKING_STATUSES = {
    PENDING: 'pending',
    CONFIRMED: 'confirmed',
    COMPLETED: 'completed',
    CANCELLED: 'cancelled'
} as const;

export const LEAD_STAGES = {
    CONTACT: 'contact',
    MEASUREMENT: 'measurement',
    BOOKING: 'booking',
    COMPLETED: 'completed',
    DROPPED: 'dropped'
} as const;

export const VALIDATION_RULES = {
    EMAIL_REGEX: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    PHONE_REGEX: /^(\+61|0)[2-9]\d{8}$/,
    MIN_NAME_LENGTH: 2,
    MAX_NAME_LENGTH: 50,
    MIN_ADDRESS_LENGTH: 10,
    MAX_ADDRESS_LENGTH: 200
};

export const COLORS = {
    PRIMARY: '#F59E0B', // Amber-500
    PRIMARY_DARK: '#D97706', // Amber-600
    SECONDARY: '#1F2937', // Gray-800
    SUCCESS: '#10B981', // Emerald-500
    ERROR: '#EF4444', // Red-500
    WARNING: '#F59E0B', // Amber-500
    INFO: '#3B82F6', // Blue-500
};
